import type { SoftwareRepoMode } from '@/types/workflow-types';

interface WorkflowSoftwareRepoFields {
  software_repo_url?: string | null;
  software_repo_branch?: string | null;
  software_repo_mode?: SoftwareRepoMode | null;
}

export const getWorkflowSoftwareRepoPayload = (
  workflow: WorkflowSoftwareRepoFields | null | undefined,
): WorkflowSoftwareRepoFields => {
  if (
    !workflow ||
    !Object.prototype.hasOwnProperty.call(workflow, 'software_repo_url')
  ) {
    // A genuinely new workflow whose status query failed must leave these
    // fields omitted so the server can apply its credential-gated default.
    return {};
  }

  // Property presence is explicit intent. In particular, null means this
  // persisted workflow has repository attachment disabled.
  return {
    software_repo_url: workflow.software_repo_url ?? null,
    software_repo_branch: workflow.software_repo_branch ?? null,
    software_repo_mode: workflow.software_repo_mode ?? null,
  };
};
